import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import BookButton from "@/components/site/BookButton";
import { PILLAR_IMAGE_MINDSET } from "@/lib/site";

export default function Solution() {
    return (
        <section
            data-testid="solution-section"
            className="relative bg-[#060c1e] py-24 md:py-32 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
                    <div className="md:col-span-6 order-2 md:order-1">
                        <div className="relative">
                            <img
                                src={PILLAR_IMAGE_MINDSET}
                                alt="Disciplined man — cinematic portrait"
                                className="w-full h-[520px] object-cover grayscale-[15%]"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#060c1e] via-transparent to-transparent" />
                            <div className="absolute -bottom-6 -right-6 hidden md:block">
                                <div className="bg-[#D4AF37] text-black p-6 max-w-[220px]">
                                    <p className="font-display font-black text-3xl leading-none">
                                        90
                                    </p>
                                    <p className="text-xs uppercase tracking-[0.2em] font-bold mt-2">
                                        Days to a different man
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-6 order-1 md:order-2">
                        <Reveal>
                            <SectionLabel testId="solution-label">
                                The Solution
                            </SectionLabel>
                            <h2 className="mt-6 font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                                A 90-day operating system for the man you’re{" "}
                                <span className="text-[#D4AF37]">
                                    supposed
                                </span>{" "}
                                to be.
                            </h2>
                            <p className="mt-6 text-white/75 leading-relaxed text-base sm:text-lg">
                                90 Day Alpha is a structured coaching program
                                built around four pillars and three 30-day
                                phases. You won’t just learn — you’ll be guided,
                                trained, and held accountable until the
                                identity, skills, and lifestyle of an alpha man
                                are no longer something you study, but something
                                you live.
                            </p>
                            <ul className="mt-8 space-y-3">
                                {[
                                    "Direct coaching, weekly accountability, real-world reps",
                                    "Structured curriculum, not a content dump",
                                    "Mindset + Attraction + Lifestyle — integrated",
                                    "Premium brotherhood of men doing the work alongside you",
                                ].map((b, i) => (
                                    <li
                                        key={i}
                                        className="flex items-start gap-3 text-white/85"
                                    >
                                        <span className="w-1.5 h-1.5 bg-[#D4AF37] mt-2.5 flex-shrink-0" />
                                        <span>{b}</span>
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-10">
                                <BookButton
                                    testId="solution-book-cta"
                                    label="Apply for Consultation"
                                    size="lg"
                                />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
